import { AUTH_HEADERS } from '@libs/core';

/** Incoming request headers from `NextRequest.headers`, `next/headers` `headers()`, etc. */
export type IncomingRequestHeaders = Pick<Headers, 'get'>;

/**
 * Forwards `X-Petm-Request-Id` from the incoming request onto outbound fetch headers when present.
 */
export function appendPetmRequestId(target: Headers, incoming: IncomingRequestHeaders): void {
    const requestId = incoming.get(AUTH_HEADERS.X_PETM_REQUEST_ID);
    if (requestId) {
        target.append(AUTH_HEADERS.X_PETM_REQUEST_ID, requestId);
    }
}
